import { FC } from 'react'
import { useIntl } from 'react-intl'

import { CartTypeEnum } from '@models/cart'
import { Option } from '@models/option'

import { SelectField, SelectFieldProps } from '@components/Form/Select'

type Props = Omit<SelectFieldProps, 'options'>

const QueueNumberCartTypeSelectField: FC<Props> = (props) => {
  const intl = useIntl()

  const options: Array<Option> = [
    new Option({
      label: intl.formatMessage({
        id: 'queue_number.form.radio.clinic',
      }),
      value: CartTypeEnum.MEDICAL,
    }),
    new Option({
      label: intl.formatMessage({
        id: 'queue_number.form.radio.pharmacy',
      }),
      value: CartTypeEnum.RETAIL,
    }),
  ]

  return (
    <SelectField
      {...props}
      options={options}
      noOptionsMessage={() => {
        return intl.formatMessage({ id: 'select.no_option' })
      }}
    />
  )
}

export default QueueNumberCartTypeSelectField
